import clsx from "clsx";
import TurnaLogo, { TurnaLogoIcon } from "./TurnaLogo";

const TurnaHeaderLogo = ({ iconOnly = false, className = "" }) => {
  return iconOnly ? (
    <TurnaLogoIcon className={clsx("text-primary w-6", className)} />
  ) : (
    <TurnaLogo className={clsx("text-primary w-24 md:w-34", className)} />
  );
};

export default TurnaHeaderLogo;
